import { render, staticRenderFns } from "./comp_UserData.vue?vue&type=template&id=81ebf2f6"
import script from "./comp_UserData.vue?vue&type=script&lang=js"
export * from "./comp_UserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports